export default "__VITE_PUBLIC_ASSET__bc5cce63__"